import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=2b348724&scoped=true&"
import script from "./bank.vue?vue&type=script&lang=js&"
export * from "./bank.vue?vue&type=script&lang=js&"
import style0 from "./bank.vue?vue&type=style&index=0&id=2b348724&prod&scoped=true&lang=css&"
import style1 from "./bank.vue?vue&type=style&index=1&id=2b348724&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b348724",
  null
  
)

export default component.exports